interface CourseProps {
  catalog: string;
  hasTutorships: boolean;
  hasWorkshops: boolean;
  id: string;
  name: string;
}

interface ReinforcementsViewProps {
  courses: CourseProps[];
  isLoadingCourses: boolean;
  handleTab: (selected: number) => void;
  selectEvent: (eventId: number) => void;
}

const INITIAL_TAB = {
  id: '',
  name: 'Inscritos'
};

type LocationState = {
  courseId: string;
};

export { type ReinforcementsViewProps, type LocationState, INITIAL_TAB };
